import { Badge, Button, Card, Col } from 'react-bootstrap';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import { ConcursoPublicadoProps } from '../../providers/ConcursoProvider';

const Root = styled(Card)`
  margin: 10px 0px;
  min-width: 200px;
`;

const Header = styled(Card.Header)`
  height: 80px;
  display: flex;
  align-items: center;
`;

export const ConcursoPublicoCard = (props: ConcursoPublicadoProps) => {
  const {
    idLlamadoConcurso,
    titulo,
    cantidadCargoReserva,
    cantidadCargoSinReserva,
    tipoConcurso,
    niveles,
    etapaLlamadoConcurso,
  } = props;
  const { nombre } = tipoConcurso;
  const history = useHistory();
  const { idEtapaLlamadoConcurso } = etapaLlamadoConcurso;
  let badgeElement;

  if (idEtapaLlamadoConcurso === 9) {
    badgeElement = <Badge variant="success">Inscripción Abierta</Badge>;
  } else if (idEtapaLlamadoConcurso > 9) {
    badgeElement = <Badge variant="danger">Inscripción Cerrada</Badge>;
  } else {
    badgeElement = <Badge variant="primary">Próximo a abrir inscripción</Badge>;
  }

  return (
    <Col sm={4}>
      <Root>
        <Header>
          <Card.Title>{titulo}</Card.Title>
        </Header>
        <Card.Body>
          {badgeElement}
          <ul className="descConcurso">
            <span>ID: {idLlamadoConcurso}</span>
            <li>
              Tipo de convocatoria: <b>{nombre}</b>
            </li>
            <li>
              Cargos totales: <b>{cantidadCargoReserva + cantidadCargoSinReserva}</b>
            </li>
            <li>
              Cargos con reserva: <b>{cantidadCargoReserva}</b>
            </li>
            <li>
              Niveles: <b>{niveles || '----'}</b>
            </li>
          </ul>
        </Card.Body>
        <Card.Footer>
          <Button
            onClick={() => {
              history.push('detalle_concurso', props);
            }}
            // icon={'icono-arg-archivo-consulta'}
            variant="success"
            size="sm"
            className="float-left">
            {` Ver más`}
          </Button>
        </Card.Footer>
      </Root>
    </Col>
  );
};
